import classNames from "classnames"
import { InfoCard } from "../InfoCard"
import { NozzleSim, NozzleTable } from "./NozzleTable"
import { EditNozzleTable } from "./EditNozzleTable"
import { NodeState } from "@/components/FlowSheetEditor/services/modal"
import {isObject, isEqual} from 'lodash-es'
import { AppDispatch } from "@/store"
import { useDispatch, useSelector } from "react-redux"
import { addManualInputThunk, deleteManualInputThunk } from "@/store/flowsheet/actions"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"


interface NozzleTableWarpProps {
  title: string
  className?: string
  data: NozzleSim[]
  unit: NodeState
  reload?: () => void
}
export const NozzleTableWarp = (props: NozzleTableWarpProps) => {
  const {title, className, data, unit} = props;
  const flowSimulation = useSelector(getFlowSimulationSelector)
  
  const dispatch = useDispatch<AppDispatch>()

  const onSave = async (val: number[]) => {
    const vars = data.map((item, index) => {
      return {
        unitId: unit.id,
        attribute: item.key,
        value: val[index]
      }
    }).filter((item, index) => {
      if (data[index].eta === undefined) {
        return item.value !== undefined ? true : false
      }
      
      return isObject(data[index].eta)
    })
    const oldVars = data.filter((item) => {
      return item.eta === undefined || isObject(item.eta)
    }).map((item) => item.eta?.val)
    const hasNoChange = isEqual(oldVars, vars.map(item => item.value).filter(item => item !== undefined))
    if (hasNoChange) return;
    dispatch(addManualInputThunk({
      data: {dvars: vars},
      params: {sId: flowSimulation?.id}
    }))
  }

  const onDelete = async (index: number) => {
    const vars = [{
      unitId: unit.id,
      attribute: data[index].key,
    }]
    dispatch(deleteManualInputThunk({
      data: {dvars: vars},
      params: {sId: flowSimulation?.id}
    }))
  }

  return <InfoCard
    title={title}
    className={classNames(className)}
    action={<EditNozzleTable data={data} onSave={onSave} onDelete={onDelete} />}>

    <NozzleTable data={data} readonly={true} />
  </InfoCard>
}